module.exports = "<style>\n\t.not-found p {font-size: 15px; font-style: italic; }\n\t.not-found {min-height: 130px; }\n</style>\n\n<strong class=\"p-t p-b-sm block\" ng-show=\"inputCtrl.showTitle\">{{ inputCtrl.field.label | translate }}</strong>\n\n<div class=\"p-l-sm p-b-sm text-dark\" ng-bind-html=\"inputCtrl.field.model\" ng-if=\"inputCtrl.field.isDisabled\"></div>\n\n<text-angular \n\tng-if=\"!inputCtrl.field.isDisabled\"\n\tng-model=\"inputCtrl.field.model\" \n\tng-change=\"inputCtrl.ngChange()\" \n\tta-toolbar=\"inputCtrl.taOptions\">\n</text-angular>\n"


//////////////////
// WEBPACK FOOTER
// ./src/components/dinamic-inputs/inputText/input-textarea.html
// module id = 269
// module chunks = 0